"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapsiblePanel = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _CollapsiblePanel = require("./CollapsiblePanel.styled");
var CollapsiblePanel = exports.CollapsiblePanel = function CollapsiblePanel(_ref) {
  var panelHeaderText = _ref.panelHeaderText,
    children = _ref.children,
    isPanelOpen = _ref.isPanelOpen,
    onToggleCollapse = _ref.onToggleCollapse;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_CollapsiblePanel.StyledLabel, {
    onClick: onToggleCollapse
  }, _react["default"].createElement(_CollapsiblePanel.StyledFontAwesomeIcon, {
    icon: !isPanelOpen ? _freeSolidSvgIcons.faChevronDown : _freeSolidSvgIcons.faChevronUp
  }), panelHeaderText), _react["default"].createElement(_reactstrap.Collapse, {
    isOpen: isPanelOpen
  }, children));
};
CollapsiblePanel.propTypes = {
  panelHeaderText: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].object]),
  isPanelOpen: _propTypes["default"].bool,
  onToggleCollapse: _propTypes["default"].func.isRequired
};
CollapsiblePanel.defaultProps = {
  isPanelOpen: false
};